<!-- 购物车页 -->
<template>
  <div class="cart-box">
    <div class="prod-list">
      <div class="prod-block">
        <div class="goods-item" v-for="(item, index) in cartList" :key="index">
          <div class="item">
            <div class="btn">
              <!-- 每个商品前的按钮 -->
              <van-checkbox
                :name="item"
                @click="onchxClickFn(item, index)"
                class="checkbox-btn"
                v-model="item.checked"
              ></van-checkbox>
            </div>
            <div class="prodinfo">
              <div class="pic">
                <img :src="item.pic" alt="" />
              </div>
              <div class="opt">
                <div class="prod-name">{{ item.prodName }}</div>
                <div class="prod-center-row">
                  <div class="prod-info-text">
                    {{ item.skuName == null ? "" : item.skuName }}
                  </div>
                </div>
                <div class="price-count">
                  <div class="price">
                    <span>
                      <template v-if="activityId === 9 || activityId === 13">
                        <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px; height: 16px; margin-right: 4px;" />
                      </template>
                      <template v-else>
                        ￥
                      </template>
                    </span>
                    <span>{{ item.price.toFixed(2) }}</span>
                  </div>
                  <div class="m-numSelector">
                    <div class="minus" @click="onCountMinus(item, index)"></div>
                    <input
                      type="number"
                      name=""
                      id=""
                      :value="item.prodCount"
                    />
                    <div class="plus" @click="onCountPlus(index)"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="empty" v-if="cartList.length == 0">
      <div class="img">
        <img
          src="http://img.zhujiaxian.com/2023/03/ac746fa29b494883a054301f6be543e6.png"
        />
      </div>
      <div class="txt">还没有任何商品</div>
      <div class="log-out" @click="toClassifyPage">
        <div class="log-out-n">
          <span>去购物</span>
        </div>
      </div>
    </div>
    <!-- 下方结算 -->
    <!-- vant显示的数字不对，9999元会显示成99.99元，所以需要乘以100 -->
    <div v-else>
      <van-submit-bar
      :price="checkedGoodsAmount * 100"
      button-text="提交订单"
      @submit="onSubmit"
      :currency="activityId === 9 || activityId === 13 ? '积分' : '¥'"
    >
      <template #default>
        <van-checkbox @click="onClickCheckAll" v-model="allChecked"
          >全选</van-checkbox
        >
        <div
          style="margin-left: 20px; color: crimson; margin-inline-end: auto"
          @click="onDelete"
        >
          删除
        </div>
      </template>
    </van-submit-bar>
    <!-- 自定义价格符号区域 - 当活动ID为9时显示图片 -->
    <!-- <template v-if="activityId === 9">
      <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" 
           style="position: fixed; right: 142px; bottom: 65px; width: 16px; height: 16px; z-index: 100;" />
    </template> -->
    </div>
  </div>
</template>

<script>
import {
  GetCartData,
  UpdateCartData,
  DeleteCartData,
  ToggleCartCheckedData,
  DeleteCartData2,
} from "@/https/http";
import { Dialog } from "vant";
// 导入URL工具函数
// import { getActivityIdFromRoute } from "@/utils/urlUtil";
export default {
  name: "cart",
  data() {
    return {
      cartList: [], //商品总列表
      cartTotal: {}, //购物车数据
      // price: 0,
      goodsId: "",
      number: "",
      productId: "",
      id_: "",
      isChecked: "1",
      // productIdsList:[],
      productIds: "",
      checkedGoodsAmount: 0, //选中的商品的总金额
      checkedAll: 0,
      allChecked: false,
      // activityId: null, //活动ID
    };
  },

  methods: {
    // 获取数据
    getData() {
      let data = {
        attribute: 1,
        reqData: [],
      };
      // 发送请求，获取当前购物车的数据
      GetCartData(data).then((res) => {
       if( res.data.length!=0){
                this.cartList = res.data[0].shopCartItemDiscounts[0].shopCartItems.map(
          (item) => {
            // 默认全部选中
            item.checked = true;
            return item;
          }
        ); //商品总列表
        // 设置全选按钮为选中状态
        this.allChecked = true;
        this.checkAllSelected();
      this.toggleCartCheckedData();
       }else{
        this.cartList=[]
        this.checkAllSelected();
      this.toggleCartCheckedData();
       }

      });
    },
    toClassifyPage() {
      //this.$router.push({ name: 'searchPopup' })
      this.$router.push("/");
    },
    //减少商品数量
    onCountMinus(item, index) {
      console.log(index);
      if (item.prodCount > 1) {
        this.updateCount(index, -1);
      }
    },
    //增加商品数量
    onCountPlus(index) {
      console.log(index);
      this.updateCount(index, 1);
    },
    /**
     * 改变购物车数量接口
     */
    updateCount(index, prodCount) {
      console.log("index", index);
      let data = {
        count: prodCount,
        attribute: 1,
        prodId: this.cartList[index].prodId,
        skuId: this.cartList[index].skuId,
        shopId: 1,
      };
      UpdateCartData(data).then((res) => {
        console.log(res);
        this.getData();
        this.$eventBus.$emit( 'changeCount')
      });
    },
    // 删除单个商品的时候，发送删除商品的请求
    onDelete() {
      var basketIds = [];
      let cartList = this.cartList;
      for (var j = 0; j < cartList.length; j++) {
        if (cartList[j].checked) {
          basketIds.push(cartList[j].basketId);
        }
      }
      if (basketIds.length == 0) {
        this.$toast.fail("请选择商品");
      } else {
        Dialog.confirm({
          title: "确认要删除选中的商品吗？",
        })
          .then(() => {
            DeleteCartData2(basketIds).then((res) => {
              console.log(res);
              this.getData();
            });
          })
          .catch(() => {});
      }
      //   DeleteCartData2({ productIds: item.product_id.toString() }).then(
      //     (res) => {
      //       if (res.errno === 0) {
      //         this.getData(); //重新请求购物车商品数据，渲染
      //       }
      //     }
      //   );
    },

    //  按下商品+1或者-1按钮， 购物车商品数量变化 ,onChange会接收变化的商品id
    // onChange(value, id_) {
    //   this.cartList.forEach((item) => {
    //     // 找出对应的goods_id,number
    //     if (item.id === id_) {
    //       this.id_ = id_;
    //       this.goodsId = item.goods_id;
    //       this.number = item.number;
    //       this.productId = item.product_id;
    //     }
    //   });
    //   // 发请求
    //   this.updateCartData();
    // },

    // 购物车商品步进器功能接口  按下商品+1或者-1按钮，
    // updateCartData() {
    //   // 直接发送更新数据请求，将当前的商品数量带着
    //   UpdateCartData({
    //     goodsId: this.goodsId,
    //     id: this.id_,
    //     number: this.number,
    //     productId: this.productId,
    //   }).then((res) => {
    //     console.log(999, res);
    //     if (res.errno === 0) {
    //       this.getData(); //重新请求购物车商品数据，渲染
    //     }
    //   });
    // },

    // 点击商品单选按钮，切换购物车商品选中状态，发送请求
    onchxClickFn(item, index) {
      console.log(item, index, "item");
      this.isChecked = item.checked ? true : false;
      this.cartList[index] = item;
      console.log(this.cartList, "this.cartList");
      // console.log( item.checked );
      // this.productIds = item.basketId;
      this.checkAllSelected();
      this.toggleCartCheckedData();
    },

    // 切换购物车商品选中状态，发送请求
    toggleCartCheckedData() {
      // const productIdsArray = [this.productIds]; // 将 this.productIds 放入数组中
      let cartList = this.cartList;
      var shopCartIds = [];
      for (var j = 0; j < cartList.length; j++) {
        if (cartList[j].checked) {
          shopCartIds.push(cartList[j].basketId);
        }
      }
      ToggleCartCheckedData(shopCartIds).then((res) => {
        console.log(667, res);
        this.checkedGoodsAmount = res.data.finalMoney;
        if (res.errno === 0) {
          this.getData(); //重新请求购物车商品数据，渲染
        }
      });
    },
    /**
     * 检查全选状态
     */
    checkAllSelected() {
      var allChecked = true;
      var flag = false;
      let cartList = this.cartList;
      for (var j = 0; j < cartList.length; j++) {
        if (!cartList[j].checked) {
          console.log(allChecked, cartList[j].checked, "allChecked");
          allChecked = !allChecked;
          flag = true;
          break;
        }
      }
      if (flag) {
        this.allChecked = false;
      } else {
        this.allChecked = true;
      }
    },
    // 点击全选，切换购物车商品选中状态，发送请求
    onClickCheckAll() {
      //this.isChecked = this.allChecked ? true : false;
      //   let productIdAllList = [];

      //   this.cartList.forEach((item) => {
      //     productIdAllList.push(item.basketId);
      //   });
      var allChecked = this.allChecked ? true : false;
      //allChecked = !allChecked; //改变状态
      console.log(allChecked, "allChecked");
      let cItems = this.cartList;
      for (var j = 0; j < cItems.length; j++) {
        cItems[j].checked = allChecked;
        this.cartList = cItems;
      }

      console.log(this.cartList, " this.cartList");
      this.toggleCartCheckedData();
    },

    // 提交
    onSubmit() {
      var basketIds = [];
      let cartList = this.cartList;
      for (var j = 0; j < cartList.length; j++) {
        if (cartList[j].checked) {
          basketIds.push(cartList[j].basketId);
        }
      }
      if (basketIds.length == 0) {
        this.$toast.fail("请选择商品");
        return;
      }
      console.log(this.checkedGoodsAmount, "this.checkedGoodsAmount");
      
      sessionStorage.setItem("basketIds", basketIds);
      var valueSession = sessionStorage.getItem("basketIds");
      console.log(valueSession, "valueSession");
      this.$router.push({ name: "submit-order", params: { orderEntry: "0" } });
    },
    // 编辑地址
    onClickEditAddress() {},
  },
  created() {
    // 从路由中获取活动ID
    // const urlActivityId = getActivityIdFromRoute(this.$route);
    // // 从全局状态获取活动ID
    // const globalActivityId = this.$store.getters.getActivityId;
    
    // // 如果URL中存在活动ID，优先使用URL中的活动ID
    // if (urlActivityId) {
    //   this.activityId = urlActivityId;
    //   // 当URL中的活动ID与全局状态中的不同时，才更新全局状态
    //   if (urlActivityId !== globalActivityId) {
    //     this.$store.dispatch('updateActivityId', urlActivityId);
    //   }
    // } else if (globalActivityId) {
    //   // URL中没有活动ID，但全局状态中有，使用全局状态中的活动ID
    //   this.activityId = globalActivityId;
    // } else {
    //   // 既没有URL活动ID也没有全局活动ID时，使用默认设置
    //   this.activityId = 9;
    // }
    
    this.getData();
    console.log("xxxxcreated")
  },
};
</script>
<style scoped lang="less">
/* 购物车为空 */

.empty {
  font-size: 14px;
  color: #666;
}

/* 简化的样式，因为我们现在使用了正确的currency属性 */
  /* 自定义图片符号定位已在HTML中内联设置 */

.empty .txt {
  text-align: center;
  margin-top: 15px;
}

.empty .img {
  margin-top: 40px;
  text-align: center;
}

.empty .img img {
  width: 1rem;
  height: 1rem;
}

.log-out {
  padding: 10px;
  text-align: center;
  margin-top: 25px;
}
.log-out-n {
  font-size: 15px;
  margin: auto;
  width: 200px;
  padding: 10px;
  background: linear-gradient(90deg, #f35151 0%, #f38364 100%);
  border-radius: 133px 133px 133px 133px;
  color: #ffffff;
}

/deep/.van-checkbox__label {
  flex: 1;
}
/deep/.van-checkbox {
  margin-bottom: 2px;
}
/deep/.van-submit-bar {
  bottom: 50px;
}
.cart-box {
  padding-bottom: 150px;
  box-sizing: border-box;
  .van-card {
    position: relative;
  }
  .delete-icon {
    position: absolute;
    top: 5px;
    right: 5px;
  }
  .cart-item {
    position: relative;
    padding-left: 40px;
    .checkbox-btn {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .prod-list {
    width: 100%;
    background: #f8f8f8;
    margin-bottom: 65px;
    .prod-block {
      background: #fff;
      .goods-item {
        .item {
          background: #fff;
          display: flex;
          align-items: center;
          border-top: 1px solid #f2f2f2;
          padding: 10px;
          .btn {
            z-index: 8;
          }
          .prodinfo {
            position: relative;
            color: #999;
            width: 100%;
            display: flex;
            margin-left: 10px;
            .pic {
              text-align: center;
              width: 90px;
              height: 90px;
              line-height: 90px;
              font-size: 0;
              img {
                width: 90px;
                height: 90px;
                line-height: 90px;
                max-width: 100%;
                max-height: 100%;
                vertical-align: middle;
              }
            }
          }
          .prodinfo:after {
            height: 0;
          }
          .prodinfo:after {
            content: "";
            background-color: #f4f4f4;
            left: 0;
            height: 1px;
            transform-origin: 50% 100% 0;
            bottom: -20rpx;
            position: absolute;
            display: block;
            width: 642rpx;
            padding-left: 20rpx;
          }
          .opt {
            font-size: 14px;
            margin-left: 10px;
            width: 75%;
            .prod-name {
              color: #333;
              max-height: 36px;
              line-height: 18px;
              display: -webkit-box;
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .prod-center-row {
              .prod-info-text {
                color: #999;
                display: inline-block;
                -webkit-line-clamp: 1;
                height: 24px;
                line-height: 24px;
                background: #f9f9f9;
                padding: 0 5px 0 5px;
                border-radius: 2px;
                margin: 5px 0 0px 0;
                overflow: hidden;
                font-size: 12px;
                position: relative;
                font-family: arial;
              }
            }
            .price-count {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .price {
                color: #e43130;
                font-family: Arial;
                display: inline-block;
                .symbol {
                  font-size: 12px;
                }
              }
              .m-numSelector {
                float: right;
                .minus {
                  border-right: 0;
                  border-top-left-radius: 2px;
                  border-bottom-left-radius: 2px;
                  float: left;
                  box-sizing: border-box;
                  height: 28px;
                  border: 1px solid #d9d9d9;
                  width: 28px;
                  position: relative;
                }
                .minus:before {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                  content: " ";
                  width: 11px;
                  height: 1.5px;
                  background-color: #7f7f7f;
                  margin-top: auto;
                  margin-right: auto;
                  margin-bottom: auto;
                  margin-left: auto;
                }
                input {
                  width: 28px;
                  text-align: center;
                  color: #333;
                  float: left;
                  box-sizing: border-box;
                  height: 28px;
                  border: 1px solid #d9d9d9;
                }
                .plus {
                  border-left: 0;
                  border-top-right-radius: 2px;
                  border-bottom-right-radius: 2px;
                  float: left;
                  box-sizing: border-box;
                  height: 28px;
                  border: 1px solid #d9d9d9;
                  position: relative;
                  width: 28px;
                }
                .plus:after {
                  transform: rotate(90deg);
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                  content: " ";
                  width: 11px;
                  height: 1.5px;
                  background-color: #7f7f7f;
                  margin-top: auto;
                  margin-right: auto;
                  margin-bottom: auto;
                  margin-left: auto;
                  visibility: visible;
                }
                .plus:before {
                  position: absolute;
                  visibility: visible;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                  content: " ";
                  width: 11px;
                  height: 1.5px;
                  background-color: #7f7f7f;
                  margin-top: auto;
                  margin-right: auto;
                  margin-bottom: auto;
                  margin-left: auto;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
